(() => {
  if (window.nStickyProductAddReady) return;
  window.nStickyProductAddReady = true;

  const getPrimaryAddButton = () => {
    const buyActions = document.getElementById('n-primary-buy-actions');
    if (!buyActions) return null;

    return buyActions.querySelector(
      'button[name="add"], input[name="add"], .product-form__submit'
    );
  };

  const getInterestButton = () =>
    document.querySelector('[data-n-fantasia-interest-open]:not([hidden])');

  const setLoading = (stickyButton, loading) => {
    if (loading) {
      stickyButton.dataset.defaultLabel ||= stickyButton.textContent.trim();
      stickyButton.dataset.loading = 'true';
      stickyButton.setAttribute('aria-busy', 'true');
      stickyButton.setAttribute('aria-disabled', 'true');
      stickyButton.textContent = stickyButton.dataset.loadingLabel || 'Aggiungo al carrello…';
      return;
    }

    stickyButton.dataset.loading = 'false';
    stickyButton.removeAttribute('aria-busy');
    stickyButton.removeAttribute('aria-disabled');
    stickyButton.textContent = stickyButton.dataset.defaultLabel || stickyButton.textContent;
  };

  const watchRequest = (stickyButton, primaryButton) => {
    let requestStarted = false;
    let fallbackTimer;

    const isNativeLoading = () =>
      primaryButton.classList.contains('loading') ||
      primaryButton.getAttribute('aria-disabled') === 'true';

    const finish = () => {
      observer.disconnect();
      clearTimeout(fallbackTimer);
      setLoading(stickyButton, false);
    };

    const check = () => {
      if (isNativeLoading()) {
        requestStarted = true;
        return;
      }

      if (requestStarted) finish();
    };

    const observer = new MutationObserver(check);
    observer.observe(primaryButton, {
      attributes: true,
      attributeFilter: ['class', 'disabled', 'aria-disabled'],
    });

    // Evita uno stato bloccato se il tema non espone lo stato del pulsante
    // oppure se una richiesta termina in modo inatteso.
    fallbackTimer = setTimeout(finish, 15000);
    requestAnimationFrame(() => {
      check();
      if (!requestStarted) {
        clearTimeout(fallbackTimer);
        fallbackTimer = setTimeout(finish, 1500);
      }
    });
  };

  document.addEventListener('click', (event) => {
    const stickyButton = event.target.closest('[data-sticky-product-add]');
    if (!stickyButton) return;

    if (stickyButton.dataset.loading === 'true') {
      event.preventDefault();
      return;
    }

    const primaryButton = getPrimaryAddButton();
    const interestButton = getInterestButton();

    if (interestButton || stickyButton.dataset.nInterestMode === 'true') {
      event.preventDefault();
      interestButton?.click();
      return;
    }

    // Se il pulsante principale non e disponibile, conserva il normale link
    // di fallback che riporta l'utente al blocco di acquisto.
    if (
      !primaryButton ||
      primaryButton.disabled ||
      primaryButton.getAttribute('aria-disabled') === 'true' ||
      primaryButton.classList.contains('loading')
    ) {
      return;
    }

    event.preventDefault();

    const form = primaryButton.form;
    if (form && !form.checkValidity()) {
      const invalidField = form.querySelector(':invalid');
      invalidField?.scrollIntoView({ block: 'center', behavior: 'smooth' });
      invalidField?.focus({ preventScroll: true });
      form.reportValidity();
      return;
    }

    setLoading(stickyButton, true);
    watchRequest(stickyButton, primaryButton);
    primaryButton.click();
  });
})();
